var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_setup.dialogProps)?_c(_setup.PgDialogSelect,_vm._b({attrs:{"visible":_setup.visible},on:{"close":function($event){return _setup.onOk('cacel')},"closed":_setup.closed,"on-ok":_setup.onOk}},'PgDialogSelect',_setup.dialogProps,false)):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }